  <main>
    <mat-sidenav-container #sidenav class="main-container">
      <!-- sidebar menu  -->
      <mat-sidenav #sidebar mode="over" class="sidebar-container">
        <app-sidebar-list></app-sidebar-list>
      </mat-sidenav>

      <div class="my-content">
        <!-- header -->
        <ev-header></ev-header>
        <span></span>

      <!-- main content of the page -->
      <div class="content">
        <router-outlet (activate)="changeOfRoutes()"></router-outlet>
      </div>

    </div>
  </mat-sidenav-container>
</main>


// WEBPACK FOOTER //
// ./src/app/private/private.component.html